// extracted by mini-css-extract-plugin
module.exports = {"albums-container":"Albums_albums-container__352IT","no-albums-container":"Albums_no-albums-container__1Y3Gt","no-albums-text":"Albums_no-albums-text__34H3z"};